import TopTicker from './components/TopTicker';
import SiteHeader from './components/SiteHeader';
import HeroUpdate from './components/HeroUpdate';
import StatBar from './components/StatBar';
import FlashFeed from './components/FlashFeed';
import HotRank from './components/HotRank';
import CategoryZones from './components/CategoryZones';
import CommentBuzz from './components/CommentBuzz';
import SubmitSection from './components/SubmitSection';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 flex flex-col">
      <TopTicker />
      <SiteHeader />
      <main className="flex-1 w-full">
        <HeroUpdate />
        <StatBar />
        <FlashFeed />
        <HotRank />
        <CategoryZones />
        <CommentBuzz />
        <SubmitSection />
      </main>
      <SiteFooter />
    </div>
  );
}